import { render, staticRenderFns } from "./licenceTabs.vue?vue&type=template&id=6fda6c4f&"
import script from "./licenceTabs.vue?vue&type=script&lang=js&"
export * from "./licenceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports